"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _driverInfo = require("@/api/cms/driverInfo");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'DriverInfoManagement',
  data: function data() {
    return {
      searchLoading: false,
      searchForm: {
        realName: '',
        phone: ''
      },
      tableData: [],
      pagination: {
        page: 0,
        pageSize: 10,
        total: 0
      },
      createVisible: false,
      createLoading: false,
      createForm: {
        realName: '',
        gender: 1,
        phone: '',
        age: undefined,
        drivingYears: undefined,
        qwUserid: '',
        department: ''
      },
      createRules: {
        realName: [{
          required: true,
          message: '请输入司机姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }]
      },
      qywxVisible: false,
      qywxUserList: [],
      editVisible: false,
      editLoading: false,
      editForm: {
        id: null,
        realName: '',
        gender: 1,
        phone: '',
        age: undefined,
        drivingYears: undefined
      },
      editRules: {
        realName: [{
          required: true,
          message: '请输入司机姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }]
      }
    };
  },
  activated: function activated() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      this.searchLoading = true;
      var params = {
        page: this.pagination.page,
        size: this.pagination.pageSize
      };

      if (this.searchForm.realName) {
        params.realName = this.searchForm.realName;
      }

      if (this.searchForm.phone) {
        params.phone = this.searchForm.phone;
      }

      (0, _driverInfo.getDriverInfoList)(params).then(function (response) {
        if (response.code === 200) {
          _this.tableData = response.data.content || [];
          _this.pagination.total = response.data.totalElements || 0;
        }
      }).finally(function () {
        _this.searchLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 0;
      this.loadData();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        realName: '',
        phone: ''
      };
      this.pagination.page = 0;
      this.loadData();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.page = 0;
      this.loadData();
    },
    handlePageChange: function handlePageChange(page) {
      this.pagination.page = page - 1;
      this.loadData();
    },
    openCreateDialog: function openCreateDialog() {
      this.createForm = {
        realName: '',
        gender: 1,
        phone: '',
        age: undefined,
        drivingYears: undefined,
        qwUserid: '',
        department: ''
      };
      this.createVisible = true;
    },
    handleCreate: function handleCreate() {
      var _this2 = this;

      this.$refs.createForm.validate(function (valid) {
        if (!valid) return;
        _this2.createLoading = true;

        var data = _objectSpread({}, _this2.createForm);

        if (!data.age) delete data.age;
        if (!data.drivingYears) delete data.drivingYears;
        (0, _driverInfo.addDriverInfo)(data).then(function (response) {
          if (response.code === 200) {
            _this2.$message.success('新增成功');

            _this2.createVisible = false;
          } else {
            _this2.$message.error(response.message || '新增失败');
          }

          _this2.loadData();
        }).finally(function () {
          _this2.createLoading = false;
        });
      });
    },
    openQywxDialog: function openQywxDialog() {
      var _this3 = this;

      this.qywxVisible = true;
      this.qywxUserList = [];
      Promise.all([(0, _driverInfo.queryQywxDeptUsers)(), (0, _driverInfo.queryQywxDepartment)()]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            usersRes = _ref2[0],
            deptRes = _ref2[1];

        if (usersRes.code !== 200) {
          _this3.$message.error(usersRes.msg || '获取企业微信用户列表失败');

          _this3.qywxVisible = false;
          return;
        }

        if (deptRes.code !== 200) {
          _this3.$message.warning(deptRes.msg || '获取部门信息失败，将不显示部门');
        }

        var departmentName = deptRes.code === 200 && deptRes.data && deptRes.data.name ? deptRes.data.name : '';
        _this3.qywxUserList = (usersRes.data.content || []).map(function (u) {
          return _objectSpread(_objectSpread({}, u), {}, {
            departmentName: departmentName
          });
        });
      }).catch(function () {
        _this3.$message.error('获取企业微信数据失败，请稍后重试');

        _this3.qywxVisible = false;
      });
    },
    handleQywxSelect: function handleQywxSelect(row) {
      this.createForm.realName = row.name;
      this.createForm.qwUserid = row.userid;
      this.createForm.department = row.departmentName;
      this.qywxVisible = false;
    },
    openEditDialog: function openEditDialog(row) {
      this.editForm = {
        id: row.id,
        realName: row.realName,
        gender: row.gender,
        phone: row.phone,
        age: row.age,
        drivingYears: row.drivingYears
      };
      this.editVisible = true;
    },
    handleEdit: function handleEdit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (!valid) return;
        _this4.editLoading = true;

        var data = _objectSpread({}, _this4.editForm);

        if (!data.age) delete data.age;
        if (!data.drivingYears) delete data.drivingYears;
        (0, _driverInfo.updateDriverInfo)(data).then(function (response) {
          if (response.code === 200) {
            _this4.$message.success('修改成功');

            _this4.editVisible = false;

            _this4.loadData();
          } else {
            _this4.$message.error(response.message || '修改失败');
          }
        }).finally(function () {
          _this4.editLoading = false;
        });
      });
    },
    handleDelete: function handleDelete(row) {
      var _this5 = this;

      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u53F8\u673A\u300C".concat(row.realName, "\u300D\u5417\uFF1F\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\u3002"), '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _driverInfo.deleteDriverInfo)(row.id).then(function (response) {
          if (response.code === 200) {
            _this5.$message.success('删除成功');

            _this5.loadData();
          } else {
            _this5.$message.error(response.message || '删除失败');
          }
        });
      }).catch(function () {});
    }
  }
};
exports.default = _default;